import * as Sentry from '@sentry/react'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string

const initSentry = () => {
    if (!SENTRY_DSN) {
        console.info('SENTRY_DSN not defined')
        return
    }

    Sentry.init({
        environment: import.meta.env.VITE_ENV as string,
        dsn: SENTRY_DSN,
        release: import.meta.env.VITE_APP_VERSION as string, // Enables source map resolution in Sentry
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
            Sentry.captureConsoleIntegration({ levels: ['error'] }),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled.
        // Use subdomains of wonderlyar.com only
        tracePropagationTargets: [/https:\/\/[a-zA-Z0-9-]+\.wonderlyar\.com/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        // Enhanced error capture for better debugging
        attachStacktrace: true, // Attach stack traces to all messages, not just errors
        maxValueLength: 1024, // Capture more detail in error messages
    })
}

export default function init() {
    initSentry()
}
